import { fmtDate } from "@/lib/fmt";

// Native <input type="date"> renders per device locale; MFG standard is MM-DD-YYYY, so we echo the picked value right after the picker.
const HINT = "mfg-date-hint";
const hints = new WeakMap();

const render = (input) => {
  if (!input.isConnected) return;
  let hint = hints.get(input);
  const v = input.value;
  const text = v ? (input.type === "datetime-local" ? fmtDate(v.slice(0, 10)) + v.slice(10).replace("T", " ") : fmtDate(v, "")) : "";
  if (!text) { if (hint) { hint.remove(); hints.delete(input); } return; }
  if (!hint) {
    hint = document.createElement("small");
    hint.className = HINT;
    hint.setAttribute("data-testid", "date-hint");
    hint.setAttribute("aria-hidden", "true");
    hint.style.cssText = "display:inline-block;margin-left:6px;font-size:10px;line-height:1;color:#737373;font-weight:700;letter-spacing:.02em;vertical-align:middle;white-space:nowrap;";
    input.insertAdjacentElement("afterend", hint);
    hints.set(input, hint);
  }
  if (hint.textContent !== text) hint.textContent = text;
};

const isDateInput = (el) => el instanceof HTMLInputElement && (el.type === "date" || el.type === "datetime-local");

export const installDateInputHints = () => {
  if (typeof document === "undefined" || document.__mfgDateHints) return;
  if (!document.body) { document.addEventListener("DOMContentLoaded", installDateInputHints, { once: true }); return; }
  document.__mfgDateHints = true;
  const scan = (root = document) => root.querySelectorAll?.('input[type="date"],input[type="datetime-local"]').forEach(render);
  document.addEventListener("input", (e) => { if (isDateInput(e.target)) render(e.target); }, true);
  document.addEventListener("change", (e) => { if (isDateInput(e.target)) render(e.target); }, true);
  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      m.addedNodes.forEach((n) => { if (n.nodeType === 1) { if (isDateInput(n)) render(n); else scan(n); } });
      m.removedNodes.forEach((n) => { if (n.nodeType === 1 && isDateInput(n)) { const h = hints.get(n); if (h) { h.remove(); hints.delete(n); } } });
      if (m.type === "attributes" && isDateInput(m.target)) render(m.target);
    }
  });
  mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["value"] });
  // React sets .value programmatically (no event) — poll lightly so controlled inputs stay in sync.
  setInterval(() => scan(), 1500);
  scan();
};
